import { useQuery } from "@tanstack/react-query";
import React from "react";
import Loading from "../../../Shared/Loading/Loading";

const AddvertiseItem = () => {
  const { data: books = [], isLoading } = useQuery({
    queryKey: ["books"],
    queryFn: async () => {
      const res = await fetch("https://boi-poka-server.vercel.app/books");
      const data = await res.json();
      return data;
    },
  });
  if (isLoading) {
    return <Loading></Loading>;
  }
  console.log(books);
  return (
    <div className="px-4 py-5 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 ">
      <div>
        {/* {books?.map((book) => (
          <div className={(book?.advertise && !book?.paid) || "hidden"}>
            
          </div>
        ))} */}
        <h2 className="text-4xl font-bold text-teal-600 text-center py-10">
          Advertise Items
        </h2>
      </div>
      <div className="grid lg:grid-cols-3 gap-5">
        {books?.map((book) => (
          <div className={(book?.advertise && !book?.paid) || "hidden"}>
            <div className="max-w-xs p-6 rounded-md shadow-md dark:bg-gray-100 dark:text-gray-900">
              <div className="flex items-center space-x-2 mb-3">
                <img
                  src={book?.sellerPhoto}
                  alt=""
                  className="object-cover object-center w-8 h-8 rounded-full shadow-sm dark:bg-gray-500 dark:border-gray-700"
                />
                <div className="-space-y-1">
                  <h2 className="text-sm font-semibold leading-none">
                    {book?.sellerName}
                  </h2>
                  <span className="inline-block text-xs leading-none dark:text-gray-400">
                    {book?.sellerEmail}
                  </span>
                </div>
              </div>
              {/* <span className="block text-xs font-bold tracking-widest  dark:text-violet-400 pb-5">
                advertised item
              </span> */}
              <img
                src={book?.image}
                alt=""
                className="object-cover object-center w-full rounded-md h-72 dark:bg-gray-500"
              />
              <div className="mt-6 mb-2">
                <span className="block text-xs font-bold tracking-widest  dark:text-violet-400 pb-5">
                  ${book?.data?.resalePrice}
                </span>
                <h2 className="text-xl font-bold text-center tracking-wide">
                  {book?.data?.productName}
                </h2>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AddvertiseItem;
